module.exports = __webpack_public_path__ + "assets/img/creditcard.052b114f.svg";